import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SelectActionPage } from './select-action';

@NgModule({
  declarations: [
    SelectActionPage,
  ],
  imports: [
    IonicPageModule.forChild(SelectActionPage),
  ],
})
export class SelectActionPageModule {}



// WEBPACK FOOTER //
// ./src/pages/select-action/select-action.module.ts